export const applicationKeys = {
  all: () => ['applications'],
  application: (id: string) => [...applicationKeys.all(), id],
};
